import { oddsUpdateIndicatorClass } from "../../PrePack";
export function handleOddsAnimationEnd(element) {
    if (element) {
        element.classList.remove(oddsUpdateIndicatorClass);
    }
}
//# sourceMappingURL=handleOddsAnimationEnd.js.map